export default __webpack_public_path__ + "static/media/gfoxgif.78b23624.gif";